<div class="modal-header">
  <h4 class="modal-title pull-left"> Save Filter </h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <ng-container *ngIf="newFilter; else questionTemplate">
    <form name="form" #f="ngForm" novalidate>
      <div class="form-group">
        <label class="rbv-label">Name</label>
        <input type="text" maxlength="60" name="NAME" [(ngModel)]="name" #NAME="ngModel" class="rbv-field form-control rounded-0" required>
      </div>
    </form>
  </ng-container>

  <ng-template #questionTemplate>
    Do you want to override <b>{{preference?.NAME}}</b> Filter?
  </ng-template>
</div>

<div class="modal-footer">
  <div class="action-block">
    <div class="actions">
      <button type="button" class="btn btn-rbv" (click)="onNewFilter()">
        New Filter
      </button>
    </div>

    <div class="actions">
      <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
      <button *ngIf="!newFilter" class="btn btn-rbv" (click)="onConfirm()">Accept</button>
      <button *ngIf="newFilter" class="btn btn-rbv" [disabled]="!name" (click)="onSubmit()">Save</button>
    </div>
  </div>
</div>
